import React from 'react';
import { Stethoscope, HeartPulse, Accessibility, ShoppingBag, Users, MapPin } from 'lucide-react';
import { motion } from 'framer-motion';
const services = [{
  title: 'Medical Appointments',
  description: 'Punctual transportation to doctor visits, ensuring you never miss an important consultation.',
  icon: Stethoscope,
  color: 'bg-blue-100 text-blue-600'
}, {
  title: 'Dialysis Treatment',
  description: 'Reliable recurring transportation for dialysis patients with a focus on comfort and timing.',
  icon: HeartPulse,
  color: 'bg-red-100 text-red-600'
}, {
  title: 'Physical Therapy',
  description: 'Safe door-to-door rides for your rehabilitation and therapy sessions.',
  icon: Accessibility,
  color: 'bg-green-100 text-green-600'
}, {
  title: 'Social Outings',
  description: 'Stay connected with friends and family. We provide rides to events, parks, and gatherings.',
  icon: Users,
  color: 'bg-purple-100 text-purple-600'
}, {
  title: 'Shopping & Errands',
  description: 'Independence for your daily needs, from grocery shopping to pharmacy visits.',
  icon: ShoppingBag,
  color: 'bg-amber-100 text-amber-600'
}, {
  title: 'Service Area',
  description: 'Proudly serving Charlotte, NC and all surrounding North Carolina communities.',
  icon: MapPin,
  color: 'bg-cyan-100 text-cyan-600'
}];
export function Services() {
  return <section id="services" className="py-24 bg-white" data-id="element-154">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-155">
        <div className="text-center mb-16" data-id="element-156">
          <h2 className="text-blue-600 font-bold tracking-wide uppercase text-sm mb-3" data-id="element-157">
            Our Services
          </h2>
          <p className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-158">
            Comprehensive Mobility Solutions
          </p>
          <p className="text-slate-600 max-w-2xl mx-auto text-lg" data-id="element-159">
            We provide non-emergency transportation solutions tailored to our
            clients’ unique needs, ensuring every journey is comfortable and
            secure.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-160">
          {services.map((service, index) => <motion.div key={service.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="p-8 rounded-2xl border border-slate-100 bg-slate-50 hover:bg-white hover:shadow-xl hover:border-blue-100 transition-all group" data-id="element-161">
              <div className={`w-14 h-14 rounded-xl flex items-center justify-center mb-6 transition-transform group-hover:scale-110 ${service.color}`} data-id="element-162">
                <service.icon className="w-7 h-7" data-id="element-163" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-164">
                {service.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-165">
                {service.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}